import React, { createContext, useContext, useState } from 'react';

const QuoteModalContext = createContext();

export const useQuoteModal = () => {
  const context = useContext(QuoteModalContext);
  if (!context) {
    throw new Error('useQuoteModal must be used within QuoteModalProvider');
  }
  return context;
};

export const QuoteModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('');

  const openModal = (service = '') => {
    setSelectedService(service);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedService('');
  };

  return (
    <QuoteModalContext.Provider value={{ isModalOpen, selectedService, openModal, closeModal }}>
      {children}
    </QuoteModalContext.Provider>
  );
};
